import { font as foundationFont } from "../foundation";

const { size } = foundationFont;

export const font = {
  desktop: {
    heading: {
      xs: size[100],  //   1rem     16px
      sm: size[125],  //   1.25rem  20px
      md: size[150],  //   1.5rem   24px
      lg: size[175],  //   1.75rem  28px
      xl: size[200],  //   2.25rem  32px
      xxl: size[225], //   2.5rem   36px
    },

    body: {
      sm: size[75],   //   0.75rem    12px
      md: size[88],   //   0.875rem   14px    default body size
    },

    button: {
      sm: size[75],   //   0.75rem    12px
      md: size[88],  //    0.88rem    14px    default button size
      lg: size[100],  //   1rem       16px
    },
  },

  mobile: {
    heading: {
      xs: size[125],  //   1.25rem   20px
      sm: size[150],  //   1.5rem    24px
      md: size[175],  //   1.75rem   28px
      lg: size[200],  //   2rem      32px
      xl: size[225],  //   2.25rem   36px
      xxl: size[250], //   2.5rem    40px
    },

    body: {
      sm: size[75],   //   0.75rem    12px
      md: size[100],  //   1rem       16px    default body size
    },

    button: {
      sm: size[88],   //   0.88rem    14px
      md: size[100],  //   1rem       16px    default button size
      lg: size[125],  //   1.25rem    20px
    },
  },
}

export default font;